export function getMatrixEnvironment() {
  // eslint-disable-next-line global-require
  return require('ducks/chat/MatrixEnvironment').get()
}

export function consumeMatrixStartup(promise) {
  return promise.catch(() => {})
}
